var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeatport(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 2,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 15.6383C18 18.0496 16.0913 20 13.6524 20C11.2489 20 9.34021 18.1028 9.34021 15.6383C9.34021 14.4858 9.78203 13.4574 10.4713 12.695L7.53756 15.6383L6 14.078L9.30486 10.7979C9.74669 10.3546 9.97644 9.7695 9.97644 9.11348V5H12.1502V9.13121C12.1502 10.3901 11.7084 11.4716 10.8247 12.3404L10.7364 12.4291C11.4963 11.7199 12.539 11.2943 13.6524 11.2943C16.1267 11.2943 18 13.2624 18 15.6383ZM16.0383 15.6383C16.0383 14.344 14.9779 13.2979 13.6701 13.2979C12.3446 13.2979 11.3019 14.3972 11.3019 15.6383C11.3019 16.9149 12.3446 17.9965 13.6524 17.9965C15.0133 17.9965 16.0383 16.8794 16.0383 15.6383Z",
    fill: "#01FF95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeatport);
export default __webpack_public_path__ + "static/media/beatport.9065d408.svg";
export { ForwardRef as ReactComponent };